module.exports = __webpack_public_path__ + "static/media/headerBGL.ac03658a.png";